import { createStore } from 'vuex'
import axios from "axios";
import { getCriticalStartupPages } from "@/utils/navigation";

function parseURL(url, config) {
  const regex = /{(.*?)}/gm;
  const matches = url.match(regex);
  if(matches) {
    matches.forEach(match => {
      const input = match.replace('{', '').replace('}', '');
      const inputPath = input.split('.');

      let replacer = config;
      inputPath.forEach(key => {
        replacer = replacer[key];
      })

      url = url.replace(match, replacer);
    })
  }

  return url
}

function parsePageConfig(pageConfig, config) {
  if(typeof pageConfig === 'string') {
    return {
      page: parseURL(pageConfig, config)
    };
  }

  if(pageConfig && typeof pageConfig === 'object' && typeof pageConfig.url === 'string') {
    return {
      page: parseURL(pageConfig.url, config),
      renderMode: pageConfig.renderMode
    };
  }

  return {
    page: ''
  };
}

export default createStore({
  state: {
    ticket: null,
    title: "PEP",
    colors: {
      headerColor: "#FFFFFF",
      themeColor: "#000000"
    },
    icons: {
      appleTouchIcon: "/img/icons/apple-touch-icon.png",
      favicon16: "/img/icons/favicon-16x16.png",
      favicon32: "/img/icons/favicon-32x32.png",
      faviconSVG: "/img/icons/favicon.ico",
      maskIcon: "/img/icons/favicon.ico",
      msTileImage: "/img/icons/mstile-150x150.png"
    },
    images: {
      logo: "",
      splash: ""
    },
    shortcuts: {},
    navigation: {},
    installButton: {
      backgroundColor: "#000000",
      textColor: "#FFFFFF",
      text: "Download WebApp"
    },
  },
  getters: {
    ticket: state => state.ticket,
    token: state => state.token,
    title: state => state.title,
    colors: state => state.colors,
    icons: state => state.icons,
    images: state => state.images,
    shortcuts: state => state.shortcuts,
    navigation: state => state.navigation,
    installButton: state => state.installButton,
    getPEP: state => state.pep
  },
  mutations: {
    SET_TICKET(state, ticket) {
      state.ticket = ticket
    },
    SET_TOKEN(state, token) {
      state.token = token
    },
    SET_TITLE(state, title) {
      state.title = title
    },
    SET_COLORS(state, colors) {
      state.colors = colors
    },
    SET_ICONS(state, icons) {
      state.icons = icons
    },
    SET_IMAGES(state, images) {
      state.images = images
    },
    SET_NAVIGATION(state, navigation) {
      state.navigation = navigation
    },
    SET_SHORTCUTS(state, shortcuts) {
      state.shortcuts = shortcuts
    },
    SET_INSTALL_BUTTON(state, installButton) {
        state.installButton = installButton
    },
    SET_PEP(state, pep) {
      state.pep = pep
    }
  },
  actions: {
    async fetchPEP({ commit }) {
      return new Promise((resolve, reject) => {
        try {
          const ticketPath = window.location.pathname;
          const ticketPathParts = ticketPath.split('/');
          const ticketID = ticketPathParts[1];
          const token = ticketPathParts[2];
          if(!ticketID) throw "TicketID not defined!";
          if(!token) throw "Token not defined!";

          axios.get('https://api.ticketpark.ch/pep/' + ticketID + '/' + token).then(data => {
          // axios.get('https://pep-api.frappant.ch/' + ticketID +  '.json').then(data => {
            const config = data.data;

            // eslint-disable-next-line no-unused-vars
            const navigation = {};
            const home = parsePageConfig(config.pep.home, config);
            navigation.home = {
              name: "Home",
              url: '/' + ticketID + '/' + token,
              page: home.page,
              renderMode: home.renderMode,
              inMenu: false
            };

            for (const [name, page] of Object.entries(config.pep.navigation.main)) {
              const pageConfig = parsePageConfig(page, config);
              navigation[name.toLowerCase()] = {
                name: name,
                url: '/' + ticketID + '/' + token + '/' + name.toLowerCase(),
                page: pageConfig.page,
                renderMode: pageConfig.renderMode,
                target: page.target,
                inMenu: true
              };
            }

            if(typeof config.pep.shortcuts !== 'undefined') {
              for (const [name, page] of Object.entries(config.pep.shortcuts)) {
                const pageConfig = parsePageConfig(page, config);
                navigation[name] = {
                  name: name,
                  url: '/' + ticketID + '/' + token + '/' + name.toLowerCase(),
                  page: pageConfig.page,
                  renderMode: pageConfig.renderMode,
                  target: page.target,
                  inMenu: false,
                };
              }
            }

            // Prefetch shell routes for critical startup pages only (home).
            // Other embeddable pages are warmed in the background after first paint.
            // target: "_blank" pages open externally and must not be preloaded/cached.
            const criticalPages = getCriticalStartupPages(navigation);
            // eslint-disable-next-line no-unused-vars
            for (const [name, item] of Object.entries(criticalPages)) {
              axios.get(item.url)
            }

            commit('SET_TICKET', ticketID)
            commit('SET_TOKEN', token)
            commit('SET_TITLE', config.pep.name)
            commit('SET_COLORS', config.colors)
            commit('SET_ICONS', config.icons)
            commit('SET_IMAGES', config.pep.images)
            commit('SET_NAVIGATION', navigation)

            if (typeof config.installButton !== 'undefined') {
              commit('SET_INSTALL_BUTTON', config.installButton)
            }
            if (typeof config.pep.shortcuts !== 'undefined') {
              commit('SET_SHORTCUTS', config.pep.shortcuts)
            }

            resolve();

          }).catch(error => {
            throw error;
          })
        }
        catch (error) {
          reject(error)
        }
      });
    }
  },
  modules: {
  }
})
